import React from 'react';

import { Text as RText } from 'react-native';
import { createThemedComponent, View } from 'dripsy';
import { abbreviateNumber } from 'utils/numbers';
import { IS_NATIVE } from '@r3l/common';

export const ButtonText = createThemedComponent(RText, {
  themeKey: 'text',
  defaultVariant: 'buttonText',
});

export const NumericalValue = createThemedComponent(RText, {
  themeKey: 'text',
  defaultVariant: 'number',
});

export const BigNumber = createThemedComponent(RText, {
  themeKey: 'text',
  defaultVariant: 'bigNumber',
});

export const CommentText = createThemedComponent(RText, {
  themeKey: 'text',
  defaultVariant: 'commentText',
});

export const BodyText = createThemedComponent(RText, {
  themeKey: 'text',
  defaultVariant: 'body',
});

export const Header = createThemedComponent(RText, {
  themeKey: 'text',
  defaultVariant: 'heading',
});

export const Title = createThemedComponent(RText, {
  themeKey: 'text',
  defaultVariant: 'title',
});

export const SecondaryText = createThemedComponent(RText, {
  themeKey: 'text',
  defaultVariant: 'smallGrey',
});

export const SmallText = createThemedComponent(RText, {
  themeKey: 'text',
  defaultVariant: 'smallBlack',
});

export const AltLink = createThemedComponent(RText, {
  themeKey: 'text',
  defaultVariant: 'altLink',
});

export const CommunityLink = createThemedComponent(RText, {
  themeKey: 'text',
  defaultVariant: 'communityLink',
});

export const Warning = createThemedComponent(RText, {
  themeKey: 'text',
  defaultVariant: 'smallBlack',
  defaultStyle: {
    color: 'warning',
  },
});

export const Err = createThemedComponent(RText, {
  themeKey: 'text',
  defaultVariant: 'smallBlack',
  defaultStyle: {
    color: 'error',
  },
});

export const Text = BodyText;
export const InlineText = BodyText;

export const Highlight = createThemedComponent(RText, {
  themeKey: 'text',
  defaultVariant: 'highlight',
});

export const CTALink = createThemedComponent(RText, {
  themeKey: 'text',
  defaultVariant: 'CTALink',
  defaultStyle: !IS_NATIVE ? { userSelect: 'none', cursor: 'pointer' } : {},
});

export const LinkFont = createThemedComponent(RText, {
  themeKey: 'text',
  defaultVariant: 'link',
  defaultStyle: !IS_NATIVE ? { userSelect: 'none', cursor: 'pointer' } : {},
});

interface BadgeInput {
  color?: string;
  textColor?: string;
  h?: number;
  number: number;
  sx: any;
}

export function Badge({
  color,
  textColor,
  h,
  number,
  sx,
}: BadgeInput): JSX.Element | null {
  if (!number) return null;
  return (
    <View
      sx={{
        bg: color || 'blue',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: (h || 1.75 * 8) / 2,
        height: 1.75 * 8,
        px: 3.01,
        minWidth: h || 1.75 * 8,
        ...sx,
      }}
    >
      <NumericalValue
        sx={{ fontSize: 10, lineHeight: 1.75 * 8, color: textColor || 'white' }}
      >
        {abbreviateNumber(number)}
      </NumericalValue>
    </View>
  );
}
